import { render, staticRenderFns } from "./DetailAppleAccountForm.vue?vue&type=template&id=fa6b8318&scoped=true&"
import script from "./DetailAppleAccountForm.vue?vue&type=script&lang=ts&"
export * from "./DetailAppleAccountForm.vue?vue&type=script&lang=ts&"
import style0 from "./DetailAppleAccountForm.vue?vue&type=style&index=0&id=fa6b8318&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa6b8318",
  null
  
)

export default component.exports